module.exports = __webpack_public_path__ + "img/Newspaper.211c7d27.jpg";